import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { logout } from "@/api/session";
import { useToast } from "@/components";

/** Ends the session, clears cached data and returns to the login page. */
export function useSignOut(): () => Promise<void> {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  return async () => {
    try {
      await logout(queryClient);
    } catch {
      toast.error("Signing out failed", {
        description: "The server didn’t respond; your session may still be active.",
      });
      return;
    }
    await navigate("/login", { replace: true });
  };
}
